import { Box, Container, Grid, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FaHandshake, FaLeaf, FaShieldAlt } from 'react-icons/fa';
import FadeInImage from '../../../components/ui/FadeInImage';
const icons = [
  <FaShieldAlt size={32} />, 
  <FaLeaf size={32} />, 
  <FaHandshake size={32} />
];

export default function NosotrosValues() {
  const { t } = useTranslation();
  const items = t('nosotros.values.items', { returnObjects: true }) as any[];

  return (
    <Box component="section" sx={{ py: 12, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
      <Container maxWidth="xl">
        <Box sx={{ textAlign: 'center', mb: 12 }}>
          <Typography variant="h3" sx={{ fontWeight: 800, color: '#0A1128', mb: 2, fontSize: { xs: '2rem', md: '2.5rem' } }}>
            {t('nosotros.values.title')}
          </Typography>
          <Box sx={{ width: 80, height: 6, bgcolor: '#68a8de', mx: 'auto', borderRadius: 4 }} />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
          {Array.isArray(items) && items.map((item, idx) => {
            const isImageRight = idx % 2 === 0;
            return (
              <Grid 
                container 
                spacing={8} 
                direction={isImageRight ? 'row' : 'row-reverse'}
                sx={{ alignItems: 'center' }} 
                key={idx}
              >
                <Grid size={{ xs: 12, md: 6 }}>
                  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                      <Box sx={{ p: 2, borderRadius: 3, bgcolor: 'rgba(104, 168, 222, 0.1)', color: '#68a8de', display: 'flex', alignItems: 'center' }}>
                        {icons[idx]}
                      </Box>
                      <Typography variant="h4" sx={{ fontWeight: 800, color: '#0A1128', fontSize: { xs: '1.5rem', md: '2rem' } }}>
                        {item.title}
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ color: '#475569', lineHeight: 1.8, fontSize: '1.1rem' }}>
                      {item.text}
                    </Typography>
                  </motion.div>
                </Grid>
                
                <Grid size={{ xs: 12, md: 6 }}>
                  <Box 
                    component={motion.div} whileHover={{ scale: 1.02 }}
                    sx={{ p: 1, bgcolor: 'white', borderRadius: 8, border: '1px solid #e2e8f0', boxShadow: '0 20px 40px rgba(0,0,0,0.03)' }}
                  >
                    <FadeInImage src={item.img} alt={item.title} sx={{ width: '100%', borderRadius: 7, display: 'block', aspectRatio: '16/10', objectFit: 'cover' }} />
                  </Box>
                </Grid>
              </Grid>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
}